<template>
    <div class="message-content">
        <div class="message-content-title">
            <h1>{{title}}</h1>
        </div>
        <div class="message-send-user-container">
            <div class="message-avatar">
                <el-avatar :size="50" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            </div>
            <div class="message-send-info-container">
                <div class="send-user">{{sendUnit}}-{{sendUser}}</div>
                <div class="send-date">{{sendDate}}</div>
            </div>
        </div>
        <div class="message-content-main-container" v-text="content">

        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageContent",
        props:{
            title: String,
            sendUser: String,
            sendUnit: String,
            sendDate: String,
            content: String
        }
    }
</script>

<style scoped lang="scss">
.message-content{
    height: 100%;
    flex: 1;
    overflow: hidden;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    .message-content-title{
        margin-left: 50px;
        margin-bottom: 10px;
        border-bottom: 1px solid #E3E8EA;
    }
    .message-send-user-container{
        margin-top: 10px;
        display: flex;
        .message-avatar {
            width: 50px;
        }
        .message-send-info-container{
            flex: 1;
            overflow: hidden;
            padding-left: 15px;
            box-sizing: border-box;
            border-bottom: 1px solid #E3E8EA;
            .send-user{
                font-size: 24px;
                color: #202124;
            }
            .send-date{
                font-size: 16px;
                color: #A1A3AF;
            }

        }
    }
    .message-content-main-container{
        margin-top: 15px;
        margin-left: 50px;
        flex: 1;
        overflow-y: auto;
        border-bottom: 1px solid #E3E8EA;
    }
}

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Messages/components/MessageContent.vue"
}
</vue-filename-injector>
